import { render, staticRenderFns } from "./ReturnWithChangeBranch.vue?vue&type=template&id=6f77c69b&scoped=true&"
import script from "./ReturnWithChangeBranch.vue?vue&type=script&lang=js&"
export * from "./ReturnWithChangeBranch.vue?vue&type=script&lang=js&"
import style0 from "./ReturnWithChangeBranch.vue?vue&type=style&index=0&id=6f77c69b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f77c69b",
  null
  
)

export default component.exports